import { Alert } from 'react-bootstrap'
import styled from 'styled-components'
import { zIndex } from 'common/constants'
export const StyledAlertNotification = styled(Alert)`
  z-index: ${zIndex.stickyAlert};
`
